var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgContacts = function SvgContacts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.499V19.499C17 18.4382 16.5786 17.4207 15.8284 16.6706C15.0783 15.9205 14.0609 15.499 13 15.499H5C3.93913 15.499 2.92172 15.9205 2.17157 16.6706C1.42143 17.4207 1 18.4382 1 19.499V21.499",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.499C11.2091 11.499 13 9.70816 13 7.49902C13 5.28988 11.2091 3.49902 9 3.49902C6.79086 3.49902 5 5.28988 5 7.49902C5 9.70816 6.79086 11.499 9 11.499Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.4989V19.4989C22.9993 18.6126 22.7044 17.7517 22.1614 17.0512C21.6184 16.3508 20.8581 15.8505 20 15.6289",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.62891C16.8604 3.84921 17.623 4.34961 18.1676 5.05122C18.7122 5.75283 19.0078 6.61574 19.0078 7.50391C19.0078 8.39208 18.7122 9.25499 18.1676 9.9566C17.623 10.6582 16.8604 11.1586 16 11.3789",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContacts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contacts.c9676a30ae45bce0330b676a505f248b.svg";